import React, { useEffect, useState } from "react";
import "./admission_news.css";
import { FaArrowRight } from "react-icons/fa";
import { Link } from "react-router-dom";

const API_BASE = process.env.REACT_APP_API_BASE_URL || "https://api.mitadtu.in";

const AdmissionNews = () => {
  const [admissionsData, setAdmissionsData] = useState([]);

  useEffect(() => {
    const fetchAdmissionsNews = async () => {
      try {
        const res = await fetch(`${API_BASE}/api/admin/latest-news/public`);
        const data = await res.json();
        setAdmissionsData(data.admissions || []);
      } catch (err) {
        console.error("Error fetching admissions news:", err);
      }
    };

    fetchAdmissionsNews();
  }, []);

  const formatDate = (dateStr) => {
    if (!dateStr) return { month: "", day: "" };

    const dateObj = new Date(dateStr);
    if (isNaN(dateObj)) return { month: "", day: "" };

    return {
      month: dateObj.toLocaleString("default", { month: "short" }),
      day: dateObj.getDate(),
    };
  };

  return (
    <div className="admission-news">
      {/* Ribbon top */}
      <div className="ribbon-top">Admission Bulletin 2026-27</div>
      <Link to="/admissions/admission-2026">
        <button className="admission-news-btn">
          Apply Now <FaArrowRight />
        </button>
      </Link>

      {/* Admissions News List */}
      <div className="admission-news-list-wrapper">
        <div className="admission-news-list">
          {[...admissionsData, ...admissionsData].map((item, index) => {
            const { month, day } = formatDate(item.news_date);

            return (
              <div key={index} className="admission-news-item">
                <div className="news-date">
                  <span className="month">{month}</span>
                  <span className="day">{day}</span>
                </div>
                <p className="admission-content">
                  {item.news_title}
                  {item.link_text && (
                    <a
                      href={item.link_url}
                      className="admission-link"
                      target="_blank"
                      rel="noreferrer"
                    >
                      {item.link_text}
                    </a>
                  )}
                </p>
              </div>
            );
          })}
        </div>
      </div>

      {/* Ribbon bottom*/}
      <div className="ribbon-bottom"></div>
    </div>
  );
};

export default AdmissionNews;
